import { IPartnerReview, RRDate } from '@raskrask-dk/raskrask-utils'

type Rating = 0 | 1 | 2 | 3 | 4 | 5

export const numToRating = (rating: string): Rating =>
    Math.round(parseFloat(rating)) as Rating

class ReviewBF {
    private _comment: string
    private _date: RRDate
    private _customer: string
    private _rating: Rating

    constructor(
        comment: string,
        date: string | RRDate,
        customer: string,
        rating: Rating
    ) {
        this._comment = comment
        this._date = typeof date === 'string' ? new RRDate(date) : date
        this._customer = customer
        this._rating = rating
    }

    get comment(): string {
        return this._comment
    }
    get date(): RRDate {
        return this._date
    }
    get customer(): string {
        return this._customer
    }
    get name(): string {
        return this.customer
    }
    get rating(): Rating {
        return this._rating
    }

    public static fromIPartnerReview(review: IPartnerReview): ReviewBF {
        const { content, createdAt, customer, rating } = review
        const ratingAsNumber = Math.round(parseFloat(rating)) as Rating
        const parsedContent = JSON.parse(content)
        return new ReviewBF(parsedContent, createdAt, customer, ratingAsNumber)
    }

    public static fromIPartnerReviews(reviews: IPartnerReview[]): ReviewBF[] {
        return reviews.map(this.fromIPartnerReview)
    }
}

export { ReviewBF }
